export default {
  namespaced: true,
  state: {
    documents: []
  },

  getters: {
    documentsAvailable: state => state.documents.length === 0 ? false : true
  },

  mutations: {
    SET_DOCUMENTS: (state, data = null) => {
      state.documents = data
    },
  },

  actions: {


  },
}